import React, {useState} from "react";
// import ConnectionFinder from '../../api/ConnectionFinder';

import Button from "../common/Button";
import LoadingGif from '../img/round-loading.gif';

import '../styles/ControlPanelStyle/DbUpdateStyle.css';

const FileUpload = ({
    uploadHandler,
    text = "Seleziona il file.",
    placeholder = "Seleziona il file",
    accept = '.pdf'
}) => {
    const [selectedFile, setSelectedFile] = useState(null);

    const [uploading, setUploading] = useState(false);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const uploadFile = async () => {
        if(!uploadHandler || !typeof(uploadHandler) === "function") {
            console.error("Missing required prop: 'uploadHandler' must be a function.");
            return;
        }
        if (!selectedFile) return alert("Seleziona un file!");

        const formData = new FormData();
        formData.append('file', selectedFile);

        setUploading(true);

        try {
            await uploadHandler(formData);

            alert("File elaborato con successo!");
        } catch (error) {
            console.error("Errore durante l'upload:", error);
            alert("Errore nel caricamento del file.");
        } finally {
            setSelectedFile({name: placeholder});
            setUploading(false);
        }
    };

    return (
        <div style={{margin: 'auto', marginTop: '0', marginLeft: '20px'}}>
            <p>{text}</p>
            <label className="custom-file-upload">
                <input 
                    type="file" 
                    name="file"
                    accept={accept} 
                    onChange={handleFileChange} 
                />
                {selectedFile ? selectedFile.name : placeholder}
            </label>
            <div style={{display: 'flex'}}>
                <Button disabled={uploading} func={uploadFile} name='Aggiorna' className={uploading ? "updateBtn to-white" : 'updateBtn'} /> 
                {uploading && <img src={LoadingGif} alt="loading" style={{height: '100%', margin: 'auto', marginLeft: '5px'}} />}
            </div>
        </div>
    )

}

export default FileUpload;